import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidBisnodeStatus',
  standalone: false,
})
export class IsValidBisnodeStatusPipe implements PipeTransform {
  transform(code: string): boolean {
    return (
      code === 'ST00' || code === 'ST41' || code === 'ST90' || code === 'STRL'
    );
  }
}
